/**
 * 本地存储工具类
 */

// 存储token
export function setToken(token) {
	localStorage.setItem('token', token)
}

// 获取token
export function getToken() {
	return localStorage.getItem('token')
}

// 移除token
export function removeToken() {
	localStorage.removeItem('token')
}

// 移除用户信息
export function removeUser() {
	localStorage.removeItem('user')
}

// 存储语言设置
export function setLanguage(lang) {
	localStorage.setItem('language', lang)
}

// 获取语言设置
export function getLanguage() {
	return localStorage.getItem('language') || 'en'
}

// 存储货币设置
export function setCurrency(currency) {
	localStorage.setItem('currency', currency)
}

// 获取货币设置
export function getCurrency() {
	return localStorage.getItem('currency') || 'USD'
}

// 存储货币符号
export function setCurrencySymbol(symbol) {
	localStorage.setItem('currency_symbol', symbol)
}

// 获取货币符号
export function getCurrencySymbol() {
	return localStorage.getItem('currency_symbol') || '$'
}

// 写入uuid
export function setUuid(val) {
	localStorage.setItem('uuid_key', val)
}

// 获取uuid
export function getUuid() {
	return localStorage.getItem('uuid_key')
}

// 移除uuid
export function removeUuid() {
	return localStorage.removeItem('uuid_key')
}

// 存储refreshToken
export function setRefreshToken(refreshToken) {
	localStorage.setItem('refreshToken', refreshToken)
}

// 获取refreshToken
export function getRefreshToken() {
	return localStorage.getItem('refreshToken')
}

// 移除refreshToken
export function removeRefreshToken() {
	return localStorage.removeItem('refreshToken')
}

// 存储用户基本信息
export function setUserInfo(userInfo) {
	localStorage.setItem('userInfo', userInfo)
}

// 获取用户基本信息
export function getUserInfo() {
	return localStorage.getItem('userInfo')
}

// 默认导出
export default {
	setToken,
	getToken,
	removeToken,
	removeUser,
	setLanguage,
	getLanguage,
	setCurrency,
	getCurrency,
	setCurrencySymbol,
	getCurrencySymbol,
	setUuid,
	getUuid,
	removeUuid,
	setRefreshToken,
	getRefreshToken,
	removeRefreshToken,
	setUserInfo,
	getUserInfo
};